/**
 * Utility functions for frequency/note conversion
 */

const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

export function frequencyToMidi(frequency: number): number {
  return 12 * Math.log2(frequency / 440) + 69;
}

export function midiToFrequency(midi: number): number {
  return 440 * Math.pow(2, (midi - 69) / 12);
}

export function frequencyToNoteName(frequency: number): string {
  const midi = Math.round(frequencyToMidi(frequency));
  const noteIndex = midi % 12;
  const octave = Math.floor(midi / 12) - 1;
  return `${NOTE_NAMES[noteIndex]}${octave}`;
}

export function median(values: number[]): number {
  if (values.length === 0) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  if (sorted.length % 2 === 0) {
    const left = sorted[mid - 1];
    const right = sorted[mid];
    return (left !== undefined && right !== undefined) ? (left + right) / 2 : 0;
  }
  return sorted[mid] ?? 0;
}

export function medianFilter(buffer: number[], newValue: number, maxSize = 5): number {
  buffer.push(newValue);
  if (buffer.length > maxSize) {
    buffer.shift();
  }
  return median(buffer);
}
